import angular from 'angular';

angular
  .module('batch', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider
        .state('batch', {
          data: {
            authorizedRole: 'USER_BO'
          }
        })
        .state('batch_details', {
          url: '/batch/{batchId:[0-9]+}',
          params: {
            activeTabName: null
          },
          component: 'batchDetails',
          resolve: {
            batch: [
              '$transition$',
              'BatchService',
              function($transition$, BatchService) {
                return BatchService.get({ batchId: $transition$.params().batchId });
              }
            ],
            activeTabName: [
              '$transition$',
              function($transition$) {
                return $transition$.params().activeTabName;
              }
            ]
          },
          data: {
            authorizedRole: 'USER_BO'
          }
        });
    }
  ]);
